import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideDfAccount } from '@df/account/df-account.module';

declare module '@df/account/account.interfaces' {
    namespace Account {
        interface INavigationItem {
            icon?: string;
            showOnMobile?: boolean;
        }
    }
}

export function provideAccount(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideDfAccount({
            navigation: [
                { label: 'Account overview', link: '/account', icon: 'icon-account', showOnMobile: true },
                { label: 'My orders', link: '/account/my-orders', icon: 'icon-cards', showOnMobile: true },
                { label: 'Address book', link: '/account/address-book', icon: 'icon-delivery', showOnMobile: false },
                { label: 'My details', link: '/account/my-details', icon: 'icon-account', showOnMobile: true },
                { label: 'Payment cards', link: '/account/saved-cards', icon: 'icon-account', showOnMobile: false },
                { label: 'Email preferences', link: '/account/my-preferences', icon: 'icon-chat', showOnMobile: false },
                { label: 'Account balance', link: '/account/store-credit', type: 'storeCredit', icon: '', showOnMobile: false },
                { label: 'Wishlist', link: '/account/wishlist', icon: 'icon-wishlist-thin', showOnMobile: false },
                { label: 'Sign out', type: 'logout', icon: 'icon-account', showOnMobile: true }
            ],
            historyLoadQty: 10
        })
    ]);
}
